module.exports = __webpack_public_path__ + "static/media/Bariol-Regular.b0f994c0.woff2";